import Toggle from "@ciq/shared/components/toggle"
import { Button } from "@ciq/shared/components/buttons"

/**
 * @typedef {Object} JobSettings
 * @property {boolean} allow_student_job - Enable Student job
 * @property {boolean} allow_class_attendance_job - Enable Class Attendance job
 * @property {boolean} allow_behavior_job - Enable Weekly Behavior job
 * @property {boolean} allow_facility_usage_job - Enable Facility Usage job
 * @property {boolean} allow_event_attendance_job - Enable Event Attendance job
 */

/**
 * @typedef {Object} JobEnableSectionProps
 * @property {JobSettings} settings - Current job enable settings
 * @property {(key: string, value: boolean) => void} onChange - Called when a toggle changes
 * @property {() => void} onSave - Called when Update button is clicked
 * @property {boolean} isLoading - Whether a save operation is in progress
 */

const JOB_TOGGLES = [
  { key: "allow_student_job", label: "Student", testId: "toggle-student" },
  { key: "allow_facility_usage_job", label: "Facility Usage", testId: "toggle-facility-usage" },
  { key: "allow_class_attendance_job", label: "Class Attendance", testId: "toggle-class-attendance" },
  { key: "allow_behavior_job", label: "Weekly Behavior", testId: "toggle-behavior" },
  { key: "allow_event_attendance_job", label: "Event Attendance", testId: "toggle-event-attendance" },
]

/**
 * Section for enabling/disabling Spark job types.
 * Displays toggles for each job type with an Update button to save changes.
 *
 * @param {JobEnableSectionProps} props - Component props
 * @returns {JSX.Element} The job enable section component
 */
export function JobEnableSection({ settings, onChange, onSave, isLoading }) {
  return (
    <div className="spark-job-enable-section">
      <div className="spark-job-enable-toggles">
        {JOB_TOGGLES.map(({ key, label, testId }) => (
          <div
            key={key}
            className="spark-job-enable-toggle"
            data-testid={testId}
          >
            <span onClick={() => onChange(key, !settings[key])}>{label}</span>
            <Toggle
              checked={settings[key]}
              disabled={isLoading}
              onChange={(checked) => onChange(key, checked)}
            />
          </div>
        ))}
      </div>
      <div className="spark-job-enable-actions">
        <Button variant="primary" disabled={isLoading} onClick={onSave}>
          Update
        </Button>
      </div>
    </div>
  )
}
